import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import NewService from "../../../components/service/admin/createService";
import Header from "../../../partials/header";
import { styles } from "./styles";

class Service extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }
  backList = () => {
    this.props.history.push("/service-admin/list");
  };
  render() {
    const { classes, t, ...props } = this.props;
    return (
      <>
        {/* <div className={classes.frameTitle}>
                    <Typography variant="h4">{t('service_admin_add_new_service')}</Typography>
                    <div className={classes.iconButton}>
                        <Link to='/service-admin/list'><IconButton className={classes.iconWrap} aria-label="Add">
                            <Icon className={classes.icon} color="disabled" > cancel_circle </Icon>
                        </IconButton></Link>
                    </div>
                </div> */}
        <Header
          session={t("service_admin_list_services")}
          title={t("service_admin_add_new_service")}
          backIcon={true}
          actionBack={() => this.backList()}
        />
        <NewService {...props} />
      </>
    );
  }
}

Service.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  adminService: state.service.adminService,
  role: state.user.user.roleId.role,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Service)));
